<router-outlet>
</router-outlet>
<app-modal-custom-host></app-modal-custom-host>

<app-spinner
    [show]="(spinnerService.spinner$ | async)?.show"
    [text]="(spinnerService.spinner$ | async)?.text || 'Espere...'"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>
<!-- <app-navbar *ngIf="!(location == '/coming-soon' || location == '/' || location == '/gym-coaching' || location == '/profile-authentication' || location == '/reset-password' || location == '/andorra-documentos' || location == '/andorra-apply' || location == '/oferta-trabajo-gral')">
</app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/coming-soon' || location == '/profile-authentication' )"></app-footer>
<ngx-scrolltop></ngx-scrolltop> -->